import React from "react";
import { Control, useController } from "react-hook-form";
import { CpInput, CpRadio } from "@components";
import { SelectDataItem } from "src/components/cp-select/common/utils";
import { FilterCondition } from "../common/filter-condition.component";
import { DataType } from "src/components/cp-data-table/types";
import { ConditionOption } from "./input-filter.helper";

export function InputConditionController({
  conditionOptions,
  control,
  dataType,
  name,
  onRemove,
  requireOperator,
  showOperatorAsText = false,
  operatorText,
}: {
  conditionOptions: ConditionOption[];
  control: Control<any>;
  dataType: DataType;
  name: string;
  onRemove?: () => void;
  requireOperator?: boolean;
  showOperatorAsText?: boolean;
  operatorText?: string;
}) {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: {
      condition: conditionOptions[0],
    },
    rules: {
      validate: {
        operator: (value) => {
          if (requireOperator && value?.condition) {
            return !!value.operator ? true : "Please select an operator";
          } else {
            return true;
          }
        },
      },
    },
    shouldUnregister: true,
  });

  const clearDisabledInput = (
    conditionId: SelectDataItem | null | undefined,
    currentValue: { filterValue: string | undefined },
  ) => {
    const selectedCondition = conditionOptions.find(
      (opt) => opt.id === conditionId?.id,
    );
    return selectedCondition?.disableInput
      ? undefined
      : currentValue?.filterValue;
  };

  return (
    <div>
      {showOperatorAsText && operatorText && (
        <div className="cp-mb-8 cp-body-small text-[var(--cp-color-app-primary-text)]">
          {operatorText}
        </div>
      )}
      {requireOperator && !showOperatorAsText && (
        <div className="cp-mb-8">
          <CpRadio
            inline
            name="operator"
            onChange={(operator) => onChange({ ...value, operator })}
            value={value?.operator}
            error={error?.message}
          >
            <CpRadio.Item id="or">Or</CpRadio.Item>
            <CpRadio.Item id="and">And</CpRadio.Item>
          </CpRadio>
        </div>
      )}
      <FilterCondition
        options={conditionOptions}
        onChange={(condition) =>
          onChange({
            ...value,
            condition,
            filterValue: clearDisabledInput(condition, value),
          })
        }
        onRemove={onRemove}
        value={value?.condition}
      />
      <CpInput
        autoFocus
        value={value?.filterValue || ""}
        onChange={(filterValue) => onChange({ ...value, filterValue })}
        placeholder="Add value"
        type={dataType === "number" ? "number" : "text"}
        disabled={!value?.condition || value?.condition?.disableInput || false}
      />
    </div>
  );
}
